<template>
  <ul id="pagination" v-if="totalPages > 1">
    <li v-for="page in pages" :key="page">
      <router-link :to="{ name: pageToGo, query: query(page) }">
        <span>{{ page }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    surveysPerPage: {
      type: String,
      default: '10',
    },
    totalSurveys: {
      type: Number,
      default: 1,
    },
    pageToGo: {
      type: String,
      default: 'home',
    },
  },
  methods: {
    query(page) {
      return {
        ...this.$route.query,
        _page: page,
      }
    },
  },
  computed: {
    pages() {
      const current = Number(this.$route.query._page)
      const range = 5
      const offset = Math.ceil(range / 2)
      const total = this.totalPages
      const pagesArray = []

      for (let i = 1; i <= total; i++) {
        pagesArray.push(i)
      }
      pagesArray.splice(0, current - offset)
      pagesArray.splice(range, total)

      return pagesArray
    },
    totalPages() {
      const total = this.totalSurveys / this.surveysPerPage
      return total !== Infinity ? Math.ceil(total) : 0
    },
  },
}
</script>

<style lang="scss" scoped>
ul#pagination {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

li {
  display: inline-block;
}

li a {
  border-radius: 2px;
  height: fit-content;
  text-decoration: none;
  color: $white;
  margin: 4px;
  @include tipography(18);
  span {
    padding: 4px 8px;
    border-radius: 2px;
  }
}

li a.router-link-exact-active,
li a:hover {
  background: $gray-7;
  color: $white;
}

li a {
  .light & {
    color: $gray-6;
    &.router-link-exact-active,
    &:hover {
      color: $white;
    }
  }
}
</style>
